import React, { PureComponent } from 'react';

import Alert from 'react-bootstrap/Alert';

import PropTypes from 'prop-types';

class SuccessAlert extends PureComponent {
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.message && !prevProps.message)
      document.querySelector('.alert').focus();
  }
  
  render() {
    return (
      <Alert show={this.props.message != null} variant="success" dismissible
        onClose={() => this.props.onClose()} tabIndex="0">
        {this.props.message}
      </Alert>
    );
  }
}

SuccessAlert.propTypes = {
  message: PropTypes.string, // the alert will not display when null
  onClose: PropTypes.func.isRequired,
};

export default SuccessAlert;
